<template>
  <!--
    Al body y no donde se monta (el armazón): con el teclado fuera el armazón
    lleva un transform que lo hace capa propia, y dentro de él el redactor (150)
    quedaba por DEBAJO de la pestaña del asistente (130), que vive en el body.
    Fuera del armazón mide lo que se ve con las variables de ui-kit viewport.js.
  -->
  <Teleport to="body">
    <Composer v-if="store.composer" ref="current" :key="store.composer.key" :options="store.composer" />
  </Teleport>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useToast } from '@general/ui-kit'
import { useAuthStore } from '@general/auth/frontend'

import Composer from './Composer.vue'
import { useMailStore } from './store'

/**
 * Mounted once, in the app's layout: the composer on top of whatever screen is
 * open, and the unread count beside «Correo» kept current — refreshed every
 * minute, and at once when the server says new mail arrived (the
 * notification stream re-emits it as a window event).
 */
const store = useMailStore()
const auth = useAuthStore()
const toast = useToast()
const { t } = useI18n()
const current = ref(null)
let timer = null

const allowed = () => Boolean(auth.user) && (auth.can?.('mail:use') ?? false)

watch(() => store.pending, async (next) => {
  if (!next) return
  await current.value?.putAway?.()
  toast.info(t('mailClient.compose.keptAsDraft'))
  store.takePending()
})

function onMail() {
  if (!allowed()) return
  store.refreshUnread()
  store.touched()
}

onMounted(() => {
  if (allowed()) store.refreshUnread()
  timer = setInterval(() => { if (allowed()) store.refreshUnread() }, 60_000)
  window.addEventListener('general:mail', onMail)
})
onBeforeUnmount(() => {
  clearInterval(timer)
  window.removeEventListener('general:mail', onMail)
})
</script>
